import type React from "react";
import { Card } from "./Card";
import { AnimatedNumber } from "./AnimatedNumber";

interface TileProps {
  label: string;
  value: number;
  format: (v: number) => string;
  delay: number;
  resetKey: number;
  accent?: string;
  sub?: string;
}

export function Tile({
  label,
  value,
  format,
  delay,
  resetKey,
  accent,
  sub,
}: TileProps): React.JSX.Element {
  return (
    <Card delay={delay}>
      <p className="text-white/40 text-[11px] font-body uppercase tracking-widest mb-3">
        {label}
      </p>
      <p
        className="font-head font-extrabold text-5xl leading-none tracking-tight"
        style={{ color: accent ?? "#FFFFFF" }}
      >
        <AnimatedNumber value={value} format={format} delay={delay} resetKey={resetKey} />
      </p>
      {sub ? <p className="text-white/30 text-[11px] font-body mt-3">{sub}</p> : null}
    </Card>
  );
}
